import { Vue, VueRouter } from './common'
import App from './App.vue'
import '@design/common/theme.scss'
import '@design/common/webstyle.scss'
import store from '@/store'
// import centerCore from './center'
// import examCore from './exam'
// import portalCore from './portal'
// import playCore from './play'
import { Message } from 'element-ui'
import Authentication from '@packages/authentication'
import permission from './permission'
import 'nprogress/nprogress.css'
import Component from './common/components'
import axios from 'axios'
import progress from 'nprogress'
import { loadCnzz, loadWebCall, loadWebFunny } from './common/common/utils'
import { ObserveVisibility } from 'vue-observe-visibility'
import ConfigCenterModule from '@api/module/common/config-center/ConfigCenterModule'
import UserModule from '@api/module/customer/user/UserModule'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'
import { NavigationGuardNext, Route } from 'vue-router'
import HomeModule from '@api/module/customer/basic-data/BasicDataModule'
import routerTip from './router/index'
import './common/interceptors'

if (process.env.NODE_ENV === 'development') {
  // require('../mocks')
}
Vue.directive('observe-visibility', ObserveVisibility)
loadWebFunny()
;(async function() {
  document.title = process.env.VUE_APP_TITLE

  class LoadingTip {
    message: any

    constructor() {
      this.message = undefined
    }

    show(message: string) {
      this.message = Message({
        iconClass: 'el-icon-loading mr5',
        message,
        customClass: 'loading-tip',
        type: 'success',
        duration: 0
      })
    }

    close() {
      this.message.close()
    }
  }

  progress.start()
  Vue.prototype.$messageLoading = new LoadingTip()
  // const center = centerCore()
  // const exam = examCore()
  // const play = playCore()
  // const portal = portalCore()
  Vue.use(Component)
  // 注册 Ui 命名空间的 vuex 模块
  try {
    await ConfigCenterModule.getNamespacesConfig()
    const authUrl = ConfigCenterModule.getIngressByName('ingress.auth')
    const ssoUrl = ConfigCenterModule.getIngressByName('ingress.sso')
    const thirdAuthUrl = ConfigCenterModule.getApplicationByName('applicationDiff.thirdLoginRedirectHost')
    const cnzzId = ConfigCenterModule.getApplicationByName('applicationDiff.cnzzId')
    const resourcePrefix = ConfigCenterModule.getApplicationByName('application.resourcesPrefix')
    loadCnzz(cnzzId)
    Vue.prototype.$util = {
      resourcePath: function(path: string) {
        return `${resourcePrefix}${path}`
      }
    }
    Vue.filter('resourcePath', Vue.prototype.$util.resourcePath)
    const $authentication = new Authentication({
      authUrl,
      ssoUrl,
      request: axios,
      appKey: process.env.VUE_APP_KEY,
      prefix: 'customer',
      thirdAuthUrl
    })
    Vue.prototype.$authentication = $authentication
    $authentication.on('logout', () => {
      UserModule.doEXitLogin()
    })
    const router = permission(
      // new VueRouter({
      //   mode: 'history',
      //   scrollBehavior() {
      //     return { x: 0, y: 0 }
      //   },
      //   routes: [...center.router, ...portal.router, ...play.router, ...exam.router] as any
      // }),
      routerTip,
      store,
      $authentication
    )
    const errorHandle = async (response: any) => {
      try {
        // 刷新token
        await $authentication.refresh()
      } catch (e) {
        try {
          // 失败请求 service ticket
          await $authentication.applyServiceTicket()
          // 成功执行 auth
          await $authentication.auth()
        } catch {
          UserModule.doEXitLogin()
          if (router.currentRoute?.meta?.needLogin) {
            LoginDialogModule.setShowLoginDialog(true)
            return response
          }
          return response
        }
      }
    }
    axios.interceptors.response.use(
      async (response: any) => {
        if (response?.response?.status === 401) {
          return errorHandle(response)
        }
        return response
      },
      async error => {
        const { response } = error
        // 判断请求放回的是否是401
        if (response?.status === 401) {
          return errorHandle(response)
        }
        return response
      }
    )
    router.beforeEach((to: Route, from: Route, next: NavigationGuardNext) => {
      const u = navigator.userAgent,
        ua = navigator.userAgent.toLowerCase(),
        isMobile =
          u.indexOf('Android') > -1 ||
          u.indexOf('Linux') > -1 ||
          !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
          ua.match(/MiCroMessenger/i)
      if (isMobile) {
        location.href = '/weixin/index.html'
      } else {
        next()
      }
    })
    router.afterEach((to: Route, from: Route) => {
      document.title = HomeModule.currentUnit.portalName || process.env.VUE_APP_TITLE
    })
    const subUnitId = ConfigCenterModule.getApplicationByName('applicationDiff.Basicdata.subUnitId')
    await HomeModule.getCurrentUnitByDomain({
      domain: window.location.hostname,
      subUnitId: subUnitId
    })
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      store,
      router,
      components: {
        App
      },
      template: '<App/>'
    })

    await loadWebCall(HomeModule.currentUnit.onlineCustomerInfo)
  } catch {
    progress.done()
    Message({
      message: '应用启动失败!',
      type: 'error'
    })
  }
})()
